import React from "react";
import "../styles/DashboardContenedor.css";

const DashboardContenedor = ({ resumenActual, resumenPrevisualizado }) => {
  if (!resumenActual) {
    return (
      <div className="dashboard-contenedor">
        <p>Cargando resumen...</p>
      </div>
    );
  }

  const { cajas, cbm, peso, pedidos, tiposMercancia } = resumenActual;
  const mostrarPrevisualizacion =
    resumenPrevisualizado &&
    (resumenActual.peso !== resumenPrevisualizado.peso ||
      resumenActual.cbm !== resumenPrevisualizado.cbm);

  return (
    <div className="dashboard-contenedor-flex">
      {/* 🔹 Bloque Izquierdo: Título */}
      <div className="dashboard-title">
        <h4>🚚 Resumen del Contenedor</h4>
      </div>

      {/* 🔹 Bloque Derecho: Columna de Datos */}
      <div className="dashboard-data-column">
        {/* Fila 1: Stats Generales */}
        <div className="dashboard-stats-row">
          <div className="stat-item">
            <strong>CBM:</strong> {cbm.toFixed(2)} m³
            {mostrarPrevisualizacion && resumenPrevisualizado.cbm !== cbm && (
              <span className="dashboard-preview-value">
                {" "}
                ({resumenPrevisualizado.cbm.toFixed(2)} m³ est.)
              </span>
            )}
          </div>
          <div className="stat-item">
            <strong>Peso:</strong> {peso.toFixed(2)} kg
            {mostrarPrevisualizacion && resumenPrevisualizado.peso !== peso && (
              <span className="dashboard-preview-value">
                {" "}
                ({resumenPrevisualizado.peso.toFixed(2)} kg est.)
              </span>
            )}
          </div>
          <div className="stat-item">
            <strong>Cajas:</strong> {cajas}
          </div>
          <div className="stat-item">
            <strong>Pedidos:</strong> {pedidos}
          </div>
        </div>

        {/* Fila 2: Tipos de Mercancía */}
        <div className="dashboard-tipos-row">
          <strong>📦 Tipos de Mercancía:</strong>
          {Object.entries(tiposMercancia).map(([tipo, cubicaje]) => (
            <div
              key={tipo}
              className="tipo-item"
              style={{ display: "flex", gap: "0.2rem" }}
            >
              <strong>{tipo}:</strong> {cubicaje.toFixed(2)} m³
              {mostrarPrevisualizacion &&
                resumenPrevisualizado.tiposMercancia &&
                resumenPrevisualizado.tiposMercancia[tipo] !== cubicaje && (
                  <span className="dashboard-preview-value">
                    {" "}
                    (
                    {resumenPrevisualizado.tiposMercancia[tipo]?.toFixed(2) ||
                      "0.00"}{" "}
                    m³ est.)
                  </span>
                )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DashboardContenedor;
